// src/components/companies/companiesList/newCompaniesList/viewListTools/view/sortCompaniesMenu/index.jsx

import SortIconSvg from "@/assets/svg/sort-icon.svg";
import FormButton from "@/components/ui/auth/FormButton";
import { useActions } from "@/hooks/useActions";
import useCompaniesListRequest from "@/hooks/useCompaniesListRequest";
// import newViewSelectors from "@/store/newView/newView.selectors";
import { Flex, Menu, MenuButton, MenuList, Text } from "@chakra-ui/react";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { listFields } from "../../../data/lists";
import PreferenceButton from "../../shared/PreferenceButton";
import ViewPreferenceItem from "../../shared/ViewPreferenceItem";
import SortDirectionSelect from "./SortDirectionSelect";
import SortOrderBySelect from "./SortOrderBySelect";
import useGetCurrentView from "@/hooks/useGetCurrentView";

const SortCompaniesMenu = () => {
  const paramsList = listFields
    ?.filter((field) => field?.isSort)
    ?.map((item) => ({
      label: item?.title,
      value: item?.orderBy,
      id: item?.id,
    }));

  const sortMenuSchema = Yup.object().shape({
    orderBy: Yup.object()
      .shape({
        value: Yup.string().required("*select the sort order"),
      })
      .required("*select the sort order"),
    direction: Yup.object()
      .shape({
        value: Yup.string().required("*has to be selected"),
      })
      .required("*has to be selected"),
  });

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(sortMenuSchema),
    defaultValues: {
      orderBy: null,
      direction: null,
    },
  });

  const { setViewParams, clearSelectedCompanies } = useActions();
  // const listParams = useSelector(newListSelectors.getListParams());
  const { currentParams, currentView } = useGetCurrentView();
  const { getCompanies } = useCompaniesListRequest();

  const sortTitle = !currentParams?.orderBy
    ? "Sort"
    : `Sorted by ${currentParams?.orderBy?.label}`;

  const onCloseHandler = (onClose) => {
    reset();
    onClose();
  };

  const onSortHandler = (data, onClose) => {
    clearSelectedCompanies();
    const options = {
      ...currentParams,
      orderBy: data?.orderBy?.value,
      direction: data?.direction?.value?.toUpperCase(),
      limit: currentParams?.limit,
      page: 1,
    };
    getCompanies({ params: options });
    reset();
    setViewParams({
      key: currentView?.id,
      params: {
        orderBy: data?.orderBy,
        direction: data?.direction?.value?.toUpperCase(),
      },
    });
    onClose();
  };

  const removeSortHandler = () => {
    clearSelectedCompanies();
    getCompanies({
      params: {
        ...currentParams,
        orderBy: undefined,
        direction: undefined,
        limit: currentParams?.limit,
        page: 1,
      },
    });
    setViewParams({
      key: currentView?.id,
      params: {
        orderBy: undefined,
        direction: undefined,
      },
    });
  };

  return (
    <Menu>
      {({ onClose, isOpen }) => (
        <>
          <PreferenceButton
            isActive={isOpen || currentParams?.orderBy}
            color={"lightYellow"}
            isClose={currentParams?.orderBy}
            closeHandler={removeSortHandler}
          >
            <MenuButton>
              <ViewPreferenceItem title={sortTitle} icon={SortIconSvg} />
            </MenuButton>
          </PreferenceButton>

          <MenuList px={"12px"} zIndex={"30"}>
            <Flex direction={"column"} rowGap={"12px"}>
              <Text
                fontSize={"12px"}
                fontWeight={"400"}
                lineHeight={"1"}
                letterSpacing={"4%"}
                textAlign={"start"}
                pb={"4px"}
                borderBottomWidth={"1px"}
                borderColor={"lightGray"}
                mt={"4px"}
              >
                Sort by
              </Text>

              <Flex align={"center"} columnGap={"12px"}>
                <SortOrderBySelect
                  control={control}
                  paramsList={paramsList}
                  errors={errors}
                />
                <SortDirectionSelect control={control} errors={errors} />
              </Flex>
              <Flex align={"center"} justify={"end"} columnGap={"8px"}>
                <FormButton
                  {...{
                    title: "Cancel",
                    button: {
                      bg: "transparent",
                      borderColor: "mainBlue",
                      borderWidth: "1px",
                      color: "mainBlue",
                      maxW: "81px",
                      h: "30px",
                      p: "0",
                      _hover: { bg: "lightBlue2" },
                      onClick: () => onCloseHandler(onClose),
                    },
                  }}
                />
                <FormButton
                  {...{
                    title: "Sort",
                    button: {
                      maxW: "81px",
                      p: "0",
                      h: "30px",
                      onClick: handleSubmit((e) => onSortHandler(e, onClose)),
                    },
                  }}
                />
              </Flex>
            </Flex>
          </MenuList>
        </>
      )}
    </Menu>
  );
};

export default SortCompaniesMenu;
